import type { ModalSize } from './types'

export const SIZE_WIDTH_MAP: Record<ModalSize, string> = {
  sm: 'w-110',
  md: 'w-165',
  lg: 'w-220',
}
